import configureStore, { history } from 'common/configure-store';
import reducer from './reducers';

export { history };

const clientStore = configureStore({}, reducer);

export default clientStore;
